var cube = require('./cube');

// app
(function(cube) {

  var bindReady = function() {
    var windowReady = false;
    cube.ready = function(callback) {
    };

    $(document).ready(function() {
    });
  };

  // bind event to APP
  var eventSpliter = /^([\w\.]+)(?:\s+(.*))?$/;
  cube.bindEvents = function(app, events, container) {

    cube.map(events, function(handler, evtStr) {
      var match = evtStr.match(eventSpliter),
      evtName = match[1],
      selector = match[2];
      method = cube.bind(app[handler], app);

      var _handler = function() {
        app[handler].apply(app, arguments);
      };

      if (!selector) {
        container.bind(evtName, _handler);
        /*
        app.onDestroy(function() {
        container.unbind(evtName, _handler);
        });
        */
      } else {
        container.delegate(selector, evtName, _handler);
        /*
        app.onDestroy(function() {
        container.undelegate(selector, evtName, _handler);
        });
        */
      }
    });
  };

  function processContainer(app) {
    var container;
    if (!app.container) {
      app.container = document.body;
    }
    container = $(app.container);

    if (!container.length || container.length > 1) {
      container = $(document.body);
    }

    app.container = container;
    app.getContainer = function() {
      return container;
    };
    return container;
  }

  cube.requireJsModule = function(jsModule) {
    throw new Error('Please replace this function requireJsModule');
  },

  window.runApp = cube.runApp = function(app) {
    if (cube.isString(app)) {
      app = cube.requireJsModule(app);
    }
    var pro = function() {};
    app = new cube.mix(pro.prototype, app);
    if (cube.isFunction(app.main)) {
      if (app.execBeforeDomready) {
        app.main();
      }
      else {
        $(document).ready(function(){
          cube.bindEvents(app, app.events, processContainer(app));
          app.main();
        });
      }
    }
    return app;
  }

})(cube);

/**
* img
*/
(function(cube) {
  cube.img = {
    getImageWrapper: function(target) {
      var wrapper = target.parentNode;
      var time = 0;
      while (wrapper && wrapper.nodeName == "A" && time < 10) {
        wrapper = wrapper.parentNode;
        time++;
      }
      return wrapper;
    },

    resizeAfterLoad: function(img, width, height, getFullPic) {
      var w = img.width;
      var h = img.height;
      return this.resize(img, w, h, width, height, getFullPic, true);
    },

    resize: function(img, w, h, width, height, getFullPic, fade) {
      var wrapper = this.getImageWrapper(img);

      if (!wrapper) return;

      // centerCorp
      if (!getFullPic) {

        wrapper.style["overflow"] = "hidden";
        wrapper.style["width"] = width + "px";
        wrapper.style["height"] = height + "px";

        var p1 = w / width;
        var p2 = h / height;

        if (p1 >= 1 && p2 >= 1) {
          if (p1 > p2) {
            w = w / p2;
            h = height;
          } else {
            w = width;
            h = h / p1;
          }
        }

        img.width = w;
        img.height = h;

        img.style["marginTop"] = (height - h) / 2 + "px";
        img.style["marginLeft"] = (width - w) / 2 + "px";

      } else {

        // centerFit
        var scallValue = ((h / height) > (w / width)) ? (h /height) : (w/width);

        img.width = w / scallValue;
        img.height = h / scallValue;

        img.style["marginTop"] = -(img.height - height) / 2 + "px";
        img.style["marginLeft"] = -(img.width - width) / 2 + "px";

      }

      img = $(img);
      wrapper = $(wrapper);

      if (fade) {
        wrapper.css('opacity', 0);
        if (wrapper.css('opacity') == 0 && img.css('opacity') == 0) {
          img.css('opacity', 1);
          wrapper.animate({"opacity": 1}, "slow");
        } else {
          if (img.css('opacity') == 0) {
            img.animate({"opacity": 1}, "slow");
          }
          if (wrapper.css('opacity') == 0) {
            wrapper.animate({"opacity": 1}, "slow");
          }
        }
      }
    },
  };

})(cube);

cube.Request = require('./request');
cube.Browser = require('./browser');

cube.view = {
  uayer: require('./view/layer'),
  DialogBase: require('./view/dialog-base'),
  AsyncDialog: require('./view/async-dialog'),
  MsgBox: require('./view/msg-box'),
};

module.exports = cube;



//////////////////
// WEBPACK FOOTER
// ./src/js/~/cube-browser.js
// module id = 45
// module chunks = 1